import React from "react";
import InjectionMouldingMetaForm from "./injectionMouldingMetaForm";
import CNCMetaForm from "./cncMetaForm";
import ExtrutionMetaForm from "./extrutionTemplateMetaForm";
import PunchPressTemplateMetaForm from "./punchPressTemplateMetaForm";

const TemplateMetaForm = ({ templateType, form, initialValues }) => {
  switch (templateType) {
    case 1:
      return (
        <InjectionMouldingMetaForm
          prefix="default_values"
          form={form}
          initialValues={initialValues}
        />
      );
    case 2:
      return (
        <ExtrutionMetaForm
          prefix="default_values"
          form={form}
          initialValues={initialValues}
        />
      );
    case 3:
      return (
        <PunchPressTemplateMetaForm
          prefix="default_values"
          form={form}
          initialValues={initialValues}
        />
      );
    case 4:
      return (
        <CNCMetaForm
          prefix="default_values"
          form={form}
          initialValues={initialValues}
        />
      );
  }
};

export default TemplateMetaForm;
